export default __webpack_public_path__ + "static/media/Sib.192784b0.png";